import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface bookingsStateType {
  searchKeyword: string;
  filters: {
    status: string;
    eventType: string[];
    chef: string;
    bookingStatus: string;
    requermentType: string[];
  };
  startDate: string;
  endDate: string;
  offset: number;
}
const FILTERS_MODEL = {
  status: '', //posible values: 'active','deactive'
  eventType: [], //oneTimeChef ,Chef For month ,Chef For Party
  chef: '', //assigned, unassigned//
  bookingStatus: '', //pending,completed,cancelled
  requermentType: [], //birthday,occasion,anniversary,party,other
};
const initialState: bookingsStateType = {
  searchKeyword: '',
  filters: FILTERS_MODEL,
  startDate: '',
  endDate: '',
  offset: 0,
};

const bookingsSlice = createSlice({
  name: 'bookings',
  initialState,
  reducers: {
    setSearchKeyword(state, action: PayloadAction<{ searchKeyword: string }>) {
      return { ...state, searchKeyword: action.payload.searchKeyword };
    },
    clearSearchKeyword(state) {
      return { ...state, searchKeyword: '' };
    },
    setOffset(state, action: PayloadAction<{ offset: number }>) {
      return { ...state, offset: action.payload.offset };
    },
    setFilters(
      state,
      action: PayloadAction<{ filters: bookingsStateType['filters'] }>
    ) {
      return { ...state, filters: action.payload.filters };
    },
    clearFilters(state) {
      return { ...state, filters: FILTERS_MODEL };
    },
    // logout(state) {
    //     return { ...state, isauthenticate: false, token: "", userDetail: {} };
    // }
  },
});

export const { setSearchKeyword, clearSearchKeyword, setOffset, clearFilters } =
  bookingsSlice.actions;
export default bookingsSlice.reducer;
